import { Chip, SxProps } from '@mui/material';
import { StatusBadgeUi } from './StatusBadgeUi';

export function StatusBadge({
  badge,
  sx,
}: {
  badge: StatusBadgeUi;
  sx?: SxProps;
}) {
  return (
    <Chip
      label={badge.text}
      sx={{
        backgroundColor: badge.backgroundColor,
        color: badge.textColor,
        fontWeight: '500',
        borderRadius: '16px',
        fontSize: '12px',
        padding: '0px',
        height: '22px',
        border: `1px solid ${badge.edgeColor}`,
        '&:hover': {
          backgroundColor: badge.backgroundColor,
          border: `1px solid ${badge.edgeColor}`,
        },
        ...sx,
      }}
    />
  );
}
